import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { TransportOperatorBusRouteService } from 'src/app/angularJS/services/transport-operator-route/transportOperatorRoute.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { DialogService } from 'src/app/angularJS/services/dialog/dialog.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A Controller used to edit an  operator service
 */
export class TransportOperatorServiceEditController {
  public static $inject = [
    'ACTToolbarService',
    '$translate',
    'userService',
    '$state',
    'transportOperatorBusRouteService',
    '$rootScope',
    'UserMessages',
    'operatorService',
    'operator',
    'LinkBuilder',
    'statusConstants',
    'dialogService',
    'breadcrumbService'
  ];

  public transportOperatorService: InterACT.Interfaces.TransportOperatorServices.TransportOperatorService;
  public startDate: Date;
  public endDate: Date;
  public selectedSchemes: Array<InterACT.Interfaces.Schemes.Scheme>;
  public currentLocale: string;

  constructor(
    private toolbarService: ACTToolbarService,
    private $translate: ng.translate.ITranslateService,
    private userService: UserService,
    private $state: ng.ui.IStateService,
    private transportOperatorBusRouteService: TransportOperatorBusRouteService,
    private $rootScope,
    private UserMessages: UserMessagesService,
    private operatorService: InterACT.Interfaces.TransportOperatorServices.TransportOperatorService,
    public operator: InterACT.Interfaces.TransportOperators.TransportOperator,
    private linkBuilder: LinkBuilder,
    private statusConstants: InterACT.Interfaces.IStatusConstants,
    private dialogService: DialogService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.activate();
  }

  /**
   * Allows a user to edit a transport operator service
   */
  public edit = () => {
    this.dialogService.showAuditReasonDialog().then((reason) => {
      this.setOperatorService();

      this.transportOperatorBusRouteService.edit(
        this.transportOperatorService.id,
        this.transportOperatorService,
        reason
      ).then(() => {
        this.$rootScope.showSpinner = false;
        this.UserMessages.showToast(
          'TOAST_MESSAGE.SERVICE.EDITED',
          { name: this.transportOperatorService.operator.name });
        this.goToPreviousState();
      });
    });
  }

  /**
   * Takes you back to the operators services list view
   */
  public goToPreviousState = () => {
    this.$state.go('operator.services', { operatorId: this.operator.id }, { reload: 'operator' });
  }

  /**
   * Sets the toolbars title, sets a scheme and loads in a list of schemes associated with the chosen operator
   */
  private activate() {
    this.transportOperatorService = this.operatorService;
    this.startDate = new Date(this.transportOperatorService.startDate);
    if (this.transportOperatorService.endDate) {
      this.endDate = new Date(this.transportOperatorService.endDate);
    }
    this.currentLocale = this.$translate.use();

    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.OPERATORS',
        sref: 'operators'
      },
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.REGISTRATIONS',
        sref: 'operator.services'
      },
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.EDIT',
        sref: 'operator.services-edit'
      }
    ]);

    this.toolbarService.getToolbar('primary').then((toolbar: any) => {
      toolbar.setTitle('HEADING.EDIT_SERVICE', { name: this.operator.name[this.currentLocale] });
    });
  }

  private setOperatorService() {
    this.transportOperatorService.operator = <any>{
      name: this.operator.name[this.currentLocale],
      identifier: undefined,
      link: this.linkBuilder.getTransportOperatorsLink(this.operator.id)
    };
    this.transportOperatorService.startDate = <any>moment(this.startDate).format('YYYY-MM-DD') + 'T00:00:00Z';
    this.transportOperatorService.endDate = this.endDate
      ? moment(this.endDate).format('YYYY-MM-DD') + 'T00:00:00Z'
      : undefined;
    this.$rootScope.showSpinner = true;

    if (this.transportOperatorService.alias.length === 0) {
      delete this.transportOperatorService.alias;
    }

    this.selectedSchemes.forEach((scheme) => {
      this.transportOperatorService.schemes.push({
        abbreviation: scheme.reference,
        link: this.linkBuilder.getSchemesLink(scheme.id)
      });
    });
    this.transportOperatorService.status = <any>this.statusConstants.ACTIVE;

    if (!this.transportOperatorService.source) {
      this.transportOperatorService.source = {
        manualEntry: true
      };
    }
  }
}